export default __webpack_public_path__ + "94289f8f2649474e169e67459fee11e8.wav";